import PropTypes from 'prop-types';
import Dialog from '@comp/Dialog/Dialog';
import Image from '@base/Image';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import { useConstantsGetValue } from '@api/hooks/useConstants';

const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalHeading = styled.span`
  margin-top: ${Spacings.SPACING_2B};
`;

const communityModalDefaultInfo = {
  title: 'Get our app to access their community',
  description:
    'Get direct updates, latest learning materials, exam strategies, tips & more on Unacademy app'
};

const EducatorCommunityModal = ({
  showModal,
  handleCommunityModalClose,
  showLogo,
  title,
  description
}) => {
  const constants = useConstantsGetValue();

  if (!constants?.communityTabEnabled) {
    return null;
  }
  return (
    <Dialog
      onClose={handleCommunityModalClose}
      dialogState={showModal}
      heading={
        <ModalHeader>
          {showLogo && (
            <Image
              src="community/community-follow.svg"
              width={48}
              height={48}
              alt="community-follow"
            />
          )}
          <ModalHeading>
            {title || communityModalDefaultInfo.title}
          </ModalHeading>
        </ModalHeader>
      }
      message={description || communityModalDefaultInfo.description}
      acceptLabel="Got it"
      acceptLabelVariant="hollow"
      acceptLabelTheme="black"
      acceptOnClick={handleCommunityModalClose}
    />
  );
};

export default EducatorCommunityModal;

EducatorCommunityModal.propTypes = {
  showModal: PropTypes.bool,
  handleCommunityModalClose: PropTypes.func,
  showLogo: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string
};

EducatorCommunityModal.defaultProps = {
  showModal: false,
  handleCommunityModalClose: () => {},
  showLogo: true,
  title: '',
  description: ''
};
